import { render, staticRenderFns } from "./IndustryNewsDetails.vue?vue&type=template&id=080da459&scoped=true&"
import script from "./IndustryNewsDetails.vue?vue&type=script&lang=js&"
export * from "./IndustryNewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./IndustryNewsDetails.vue?vue&type=style&index=0&id=080da459&scoped=true&lang=less&"
import style1 from "./IndustryNewsDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080da459",
  null
  
)

export default component.exports